import { NextSeo } from 'next-seo';
import TheKittiesPage from '../../components/TheKittiesPage';

export default function SecondLitterPage() {
  const title = 'Third Litter - Shitty Kitties';
  const description = `Third Litter is a collection of 1,069 shitty, hand-drawn, and programmatically generated NFTS on the Algorand blockchain.`;

  return (
    <div>
      <NextSeo title={title} description={description} />
      <TheKittiesPage title={'Third Litter'} gen={3} />
    </div>
  );
}
